import type React from 'react';

import type { EventRecord } from '@vlabs/api/artemy/model';
import type { Event } from '@vlabs/api/luna-api/model';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';

import { AttributesCellBase } from './AttributesCellBase';
import { AttributesMap } from './AttributesMap';

interface AttributesCellPointProps extends WithClassNameProp, WithDataTestid {
  event?: Event | EventRecord;
}

function AttributesCellPoint({
  event = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: AttributesCellPointProps): React.JSX.Element | null {
  return (
    <AttributesCellBase
      className={className}
      data-testid={dataTestId}
      displayName="AttributesCellPoint"
      event={event}
    >
      <AttributesMap
        data-testid={dataTestId}
        location={event?.location}
      />
    </AttributesCellBase>
  );
}

AttributesCellPoint.displayName = 'AttributesCellPoint';

export { AttributesCellPoint };
